import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import LeadProgressBar from "./component";
import { setProgressBarData } from "./actions";

const mapStateToProps = ({
    leadProgressBar: {
        data
    }
}) => ({
    data
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    setProgressBarDataConnect: setProgressBarData
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(LeadProgressBar);
